import { useCollaborations } from '@/hooks/useCollaborations'
import { Collaboration } from '@/redux/collaborationsApi'
import { Link } from 'react-router-dom'
import { CheckCircle, RefreshCw } from 'lucide-react'
import { Card } from '@/components/ui/card'
const ApprovedContent = () => {
  const { collaborations, refetch: refreshCampaigns } = useCollaborations()

  // Filter for live campaigns
  const approvedCampaigns = collaborations.filter((collaboration) =>
    collaboration.milestones?.some((m) => m.status === 'approved'),
  )
  return (
    <div className="pb-4 max-w-full">
      <div className="mb-4 md:mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-white">Approved Content</h1>
          <p className="text-gray-400">Content that's been approved</p>
        </div>
        <button
          onClick={() => refreshCampaigns()}
          className="text-[#C0FD72] hover:text-[#d2ff9c] flex items-center justify-center w-8 h-8 rounded-full"
        ></button>
      </div>

      {approvedCampaigns.length > 0 ? (
        <div className="space-y-4">
          {approvedCampaigns.map((campaign) => (
            <Card key={campaign.id} variant="dark" className="overflow-hidden card-hover">
              <Link
                to={
                  campaign.postLinks?.length
                    ? `/collaborations/${campaign.id}`
                    : `/collaborations/${campaign.id}/final`
                }
              >
                <div className="p-4">
                  <div className="flex items-start gap-4">
                    <div className="h-12 w-12 shrink-0 rounded overflow-hidden bg-white/20">
                      <img
                        src={campaign.brand.logo}
                        alt={campaign.brand.name}
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between">
                        <div className="max-w-[60%]">
                          <h3 className="text-lg font-medium text-white truncate">
                            {campaign.title}
                          </h3>
                          <p className="text-sm text-gray-400 truncate">
                            {campaign.brand.name} •{' '}
                            {Array.isArray(campaign.platform)
                              ? campaign.platform.join(', ')
                              : campaign.platform}
                          </p>
                        </div>
                        <div
                          className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium ${
                            campaign.postLinks?.length
                              ? 'bg-green-900/50 text-green-200 border border-green-700/50'
                              : 'bg-yellow-900/50 text-yellow-200 border border-yellow-700/50'
                          }`}
                        >
                          <CheckCircle className="h-3 w-3" />
                          <span>{campaign.postLinks?.length ? 'Live' : 'Pending'}</span>
                        </div>
                      </div>
                      <div className="mt-2 text-sm">
                        <p className="text-gray-400">
                          Approved: {new Date(campaign.approvedAt || '').toLocaleDateString()}
                        </p>
                        <div className="mt-1 flex items-center">
                          <span className="text-gray-300 font-medium mr-1">Views:</span>
                          <span className="text-white">
                            {campaign.metrics?.views.toLocaleString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </Card>
          ))}
        </div>
      ) : (
        <Card variant="dark" className="p-8 text-center">
          <CheckCircle className="h-12 w-12 mx-auto text-green-400 mb-4" />
          <h2 className="text-xl font-semibold mb-2 text-white">No Approved Content</h2>
          <p className="text-gray-400">You don't have any approved content yet.</p>
        </Card>
      )}
    </div>
  )
}
export default ApprovedContent
